import React from "react";

import { useKeycloak } from "@react-keycloak/web";

import  AuthLayout  from "../layouts/Auth";
import { Button } from "reactstrap";

const LoginComponent = () => {

    const { keycloak } = useKeycloak(); 

    return ( 
        <AuthLayout> 
            <div className="text-center">
                <h1 className="display-1 font-weight-bold">Login</h1>
                <Button color="primary" size="lg" onClick={() => keycloak.login()}>
                    Please login
                </Button>
            </div>
        </AuthLayout>
    );
}

const AuthRoute = ({ children } : any) => {

    const { keycloak } = useKeycloak();
    const isLoggedIn = keycloak.authenticated;

    // Don't aggressively refresh tokens here - let the interceptor handle it
    // keycloak.updateToken(120);

    return isLoggedIn ? children : <LoginComponent />;
};

export default AuthRoute;